import { cacheIdentifiers } from '@flopflip/types';

function toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

const FLAGS_CACHE_KEY = 'flags';
const FLAGS_REFERENCE_CACHE_KEY = 'flags-reference';
function getCachePrefix(adapterIdentifiers) {
  return `@flopflip/${adapterIdentifiers}-adapter`;
}
function encodeCacheContext(cacheContext) {
  const encodedAsJson = JSON.stringify(cacheContext);
  const hashCode = [...encodedAsJson].reduce(
  // eslint-disable-next-line no-bitwise
  (hash, c) => Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
  const encodedCacheContext = Math.abs(hashCode).toString();
  return encodedCacheContext;
}
async function importCache(cacheIdentifier) {
  let cacheModule;
  switch (cacheIdentifier) {
    case cacheIdentifiers.local:
      {
        cacheModule = await import('@flopflip/localstorage-cache');
        break;
      }
    case cacheIdentifiers.session:
      {
        cacheModule = await import('@flopflip/sessionstorage-cache');
        break;
      }
  }
  return cacheModule;
}
async function getCache(cacheIdentifier, adapterIdentifiers, cacheContext) {
  const cacheModule = await importCache(cacheIdentifier);
  const CACHE_PREFIX = getCachePrefix(adapterIdentifiers);
  const createCache = cacheModule.default;
  let encodedCacheContext = '';
  try {
    encodedCacheContext = encodeCacheContext(cacheContext);
  } catch (error) {}
  const flagsCachePrefix = [CACHE_PREFIX, encodedCacheContext].filter(Boolean).join('/');
  const flagsCache = createCache({
    prefix: flagsCachePrefix
  });
  const referenceCache = createCache({
    prefix: CACHE_PREFIX
  });
  return {
    set(flags) {
      const haveFlagsBeenWritten = flagsCache.set(FLAGS_CACHE_KEY, flags);
      if (haveFlagsBeenWritten) {
        referenceCache.set(FLAGS_REFERENCE_CACHE_KEY, [flagsCachePrefix, FLAGS_CACHE_KEY].join('/'));
      }
      return haveFlagsBeenWritten;
    },
    get() {
      return flagsCache.get(FLAGS_CACHE_KEY);
    },
    unset() {
      referenceCache.unset(FLAGS_REFERENCE_CACHE_KEY);
      return flagsCache.unset(FLAGS_CACHE_KEY);
    }
  };
}
function getCachedFlags(cacheIdentifier, adapterIdentifiers) {
  const CACHE_PREFIX = getCachePrefix(adapterIdentifiers);
  const cacheModule = cacheIdentifier === cacheIdentifiers.local ? localStorage : sessionStorage;
  const flagReferenceKey = [CACHE_PREFIX, FLAGS_REFERENCE_CACHE_KEY].join('/');
  const referenceToCachedFlags = cacheModule.getItem(flagReferenceKey);
  if (referenceToCachedFlags) {
    try {
      const cacheKey = JSON.parse(referenceToCachedFlags);
      const cachedFlags = cacheModule.getItem(cacheKey);
      if (cacheKey && cachedFlags) {
        return JSON.parse(cachedFlags);
      }
    } catch (error) {
      console.warn(`@flopflip/cache: Failed to parse cached flags from ${cacheIdentifier}.`);
    }
  }
  return {};
}
function getAllCachedFlags(adapter, cacheIdentifier) {
  if (!cacheIdentifier) {
    return {};
  }
  if (adapter.effectIds) {
    return adapter.effectIds.reduce((defaultFlags, effectId) => _objectSpread2(_objectSpread2({}, defaultFlags), getCachedFlags(cacheIdentifier, effectId)), {});
  }
  return getCachedFlags(cacheIdentifier, adapter.id);
}

const version = "14.0.2";

export { encodeCacheContext, getAllCachedFlags, getCache, getCachedFlags, version };
